import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnGH: CultureInfo = {
  name: 'en-GH',
  displayName: 'English (Ghana)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-GH',
  parent: CultureInfoEn
};
